
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronDoublePurple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.74 12.456a.874.874 0 0 1-.067 1.304 1.063 1.063 0 0 1-1.323.019l-.09-.081-5-5.077a.87.87 0 0 1-.08-1.15l.08-.092 5-5.077a1.06 1.06 0 0 1 1.413-.062.873.873 0 0 1 .146 1.213l-.08.091-4.388 4.455 4.389 4.457Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.74 12.456a.874.874 0 0 1-.067 1.304 1.063 1.063 0 0 1-1.323.019l-.09-.081-5-5.077a.87.87 0 0 1-.08-1.15l.08-.092 5-5.077a1.06 1.06 0 0 1 1.413-.062.873.873 0 0 1 .146 1.213l-.08.091-4.388 4.455 4.389 4.457Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 16 16\" fill=\"none\">\r\n  <path d=\"M7.73993 12.456C8.11144 12.8332 8.08132 13.417 7.67267 13.7599C7.29544 14.0765 6.72754 14.0772 6.3502 13.7787L6.26005 13.6978L1.26006 8.62093C0.942209 8.29819 0.915721 7.81948 1.1806 7.47074L1.26006 7.37907L6.26005 2.30215C6.63156 1.92493 7.26401 1.89713 7.67267 2.24006C8.04989 2.55661 8.10457 3.0784 7.81855 3.4535L7.73993 3.54401L3.351 7.99908L7.73993 12.456Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <path d=\"M12.7399 12.456C13.1114 12.8332 13.0813 13.417 12.6727 13.7599C12.2954 14.0765 11.7275 14.0772 11.3502 13.7787L11.2601 13.6978L6.26006 8.62093C5.94221 8.29819 5.91572 7.81948 6.1806 7.47074L6.26006 7.37907L11.2601 2.30215C11.6316 1.92493 12.264 1.89713 12.6727 2.24006C13.0499 2.55661 13.1046 3.0784 12.8185 3.4535L12.7399 3.54401L8.351 7.99908L12.7399 12.456Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/chevron-double-purple.5f479be44f17d3b25831e260271a48e0.svg"),
        {
          React: SvgChevronDoublePurple,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      